import React, { useEffect, useState, useRef } from 'react';
import api from '../../utils/api';
import { connectSocket } from '../../utils/socket';
import useAuthStore from '../../store/authStore';

const typeIcon = { new_match: '✦', invitation: '✉', status_update: '↻' };

const NotificationBell = () => {
  const { token } = useAuthStore();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({ notifications: [], unread_count: 0 });
  const ref = useRef();

  const load = () => api.get('/notifications').then(r => setData(r.data)).catch(() => {});

  useEffect(() => {
    load();
    const interval = setInterval(load, 60000);
    return () => clearInterval(interval);
  }, []);

  // WebSocket bağlantısı
  useEffect(() => {
    if (!token) return;
    const socket = connectSocket(token);
    socket.on('notification', () => load()); // yeni bildirim gelince listeyi yenile
    return () => socket.off('notification');
  }, [token]);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const markAllRead = () => api.patch('/notifications/read-all').then(load);
  const markRead = (id) => api.patch(`/notifications/${id}/read`).then(load);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button onClick={() => setOpen(o => !o)} style={{
        position: 'relative', background: 'none', border: '1px solid #e5e7eb',
        borderRadius: 8, padding: '6px 10px', cursor: 'pointer', fontSize: 16
      }}>
        🔔
        {data.unread_count > 0 && (
          <span style={{
            position: 'absolute', top: -4, right: -4,
            background: '#dc2626', color: '#fff', borderRadius: 10,
            fontSize: 10, fontWeight: 700, padding: '1px 5px', minWidth: 16, textAlign: 'center'
          }}>
            {data.unread_count > 9 ? '9+' : data.unread_count}
          </span>
        )}
      </button>

      {open && (
        <div style={{
          position: 'absolute', right: 0, top: 40, width: 'min(340px, calc(100vw - 32px))', maxHeight: 440,
          background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12,
          boxShadow: '0 8px 24px rgba(0,0,0,0.12)', overflowY: 'auto', zIndex: 100
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 16px', borderBottom: '1px solid #f3f4f6' }}>
            <span style={{ fontWeight: 600, fontSize: 14, color: '#111827' }}>Bildirimler</span>
            {data.unread_count > 0 && (
              <button onClick={markAllRead} style={{ background: 'none', border: 'none', fontSize: 12, color: '#2563eb', cursor: 'pointer' }}>
                Tümünü okundu yap
              </button>
            )}
          </div>

          {data.notifications.length === 0 ? (
            <div style={{ padding: 24, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>Bildirim yok</div>
          ) : (
            data.notifications.map(n => (
              <div key={n.id} onClick={() => !n.is_read && markRead(n.id)} style={{
                padding: '12px 16px', borderBottom: '1px solid #f9fafb',
                cursor: n.is_read ? 'default' : 'pointer',
                background: n.is_read ? '#fff' : '#f0f9ff',
                display: 'flex', gap: 10, alignItems: 'flex-start'
              }}>
                <span style={{ fontSize: 16, flexShrink: 0 }}>{typeIcon[n.type] || '•'}</span>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: n.is_read ? 400 : 600, fontSize: 13, color: '#111827' }}>{n.title}</div>
                  <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>{n.message}</div>
                  <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 4 }}>
                    {new Date(n.created_at).toLocaleString('tr-TR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
                  </div>
                </div>
                {!n.is_read && <div style={{ width: 7, height: 7, background: '#2563eb', borderRadius: '50%', flexShrink: 0, marginTop: 4 }} />}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
